import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AppNavbar from './components/layout/Navbar';
import PrivateRoute from './components/common/PrivateRoute';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import Dashboard from './pages/dashboard/Dashboard';
import Wallet from './pages/wallet/Wallet';
import Subscribe from './pages/subscribe/Subscribe';
import Referrals from './pages/referrals/Referrals';
import LevelUsers from './pages/levelusers/LevelUsers';
import ChangePassword from './pages/auth/ChangePassword';
import Fastrack from './pages/fastrack/Fastrack';
import FastrackStatus from './pages/fastrack/FastrackStatus';
import Slots from './pages/slots/Slots';
import BuySlot from './pages/slots/BuySlot';
import RenewSlot from './pages/slots/RenewSlot';
import PerformanceBonus from './pages/performance/PerformanceBonus';
import PerformanceRecords from './pages/performance/PerformanceRecords';
import Rewards from './pages/rewards/Rewards';
import RewardsStatus from './pages/rewards/RewardsStatus';
import Withdraw from './pages/wallet/Withdraw';
import WithdrawalLimits from './pages/wallet/WithdrawalLimits';
import GenerationBonus from './pages/generation/GenerationBonus';
import GenerationRecords from './pages/generation/GenerationRecords';
import Profile from './pages/profile/Profile';
import SupportTickets from './pages/support/SupportTickets';
import AccountStatus from './pages/account/AccountStatus';
import OfferCredits from './pages/account/OfferCredits';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserDetail from './pages/admin/AdminUserDetail';
import AdminPlans from './pages/admin/AdminPlans';
import AdminPayments from './pages/admin/AdminPayments';
import AdminProfileRequests from './pages/admin/AdminProfileRequests';
import AdminWithdrawals from './pages/admin/AdminWithdrawals';
import AdminFees from './pages/admin/AdminFees';
import AdminTransactions from './pages/admin/AdminTransactions';
import AdminCommissions from './pages/admin/AdminCommissions';
import AdminCommissionPayouts from './pages/admin/AdminCommissionPayouts';
import AdminUserSlotUpgrades from './pages/admin/AdminUserSlotUpgrades';
import AdminUserTotals from './pages/admin/AdminUserTotals';
import AdminPerformanceBonus from './pages/admin/AdminPerformanceBonus';
import AdminSupportTickets from './pages/admin/AdminSupportTickets';
import AdminSystemConfig from './pages/admin/AdminSystemConfig';
import AdminMissedIncome from './pages/admin/AdminMissedIncome';
import AdminMissedIncomeDetail from './pages/admin/AdminMissedIncomeDetail';
import AdminOfferCredits from './pages/admin/AdminOfferCredits';
import AdminLoginHistory from './pages/admin/AdminLoginHistory';
import AdminOfferPromos from './pages/admin/AdminOfferPromos';
import AdminOfferPromoForm from './pages/admin/AdminOfferPromoForm';

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  const user = (() => { try { return JSON.parse(localStorage.getItem('adminUser')); } catch { return null; } })();
  if (!token || user?.role !== 'admin') return <Navigate to="/panel" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <AuthProvider>
          <AppNavbar />
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/subscribe" element={<PrivateRoute><Subscribe /></PrivateRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/wallet" element={<PrivateRoute><Wallet /></PrivateRoute>} />
            <Route path="/referrals" element={<PrivateRoute><Referrals /></PrivateRoute>} />
            <Route path="/level-users" element={<PrivateRoute><LevelUsers /></PrivateRoute>} />
            <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
            <Route path="/fastrack" element={<PrivateRoute><Fastrack /></PrivateRoute>} />
            <Route path="/fastrack-status" element={<PrivateRoute><FastrackStatus /></PrivateRoute>} />
            <Route path="/slots" element={<PrivateRoute><Slots /></PrivateRoute>} />
            <Route path="/slots/buy/:planId" element={<PrivateRoute><BuySlot /></PrivateRoute>} />
            <Route path="/slots/renew/:planId" element={<PrivateRoute><RenewSlot /></PrivateRoute>} />
            <Route path="/performance-bonus" element={<PrivateRoute><PerformanceBonus /></PrivateRoute>} />
            <Route path="/performance-records" element={<PrivateRoute><PerformanceRecords /></PrivateRoute>} />
            <Route path="/rewards" element={<PrivateRoute><Rewards /></PrivateRoute>} />
            <Route path="/rewards-status" element={<PrivateRoute><RewardsStatus /></PrivateRoute>} />
            <Route path="/withdraw" element={<PrivateRoute><Withdraw /></PrivateRoute>} />
            <Route path="/withdrawal-limits" element={<PrivateRoute><WithdrawalLimits /></PrivateRoute>} />
            <Route path="/generation-bonus" element={<PrivateRoute><GenerationBonus /></PrivateRoute>} />
            <Route path="/generation-records" element={<PrivateRoute><GenerationRecords /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/support-tickets" element={<PrivateRoute><SupportTickets /></PrivateRoute>} />
            <Route path="/account-status" element={<PrivateRoute><AccountStatus /></PrivateRoute>} />
            <Route path="/offer-credits" element={<PrivateRoute><OfferCredits /></PrivateRoute>} />

            {/* Admin */}
            <Route path="/panel" element={<AdminLogin />} />
            <Route path="/panel" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route path="dashboard"    element={<AdminDashboard />} />
              <Route path="users"        element={<AdminUsers />} />
              <Route path="users/:id"    element={<AdminUserDetail />} />
              <Route path="plans"        element={<AdminPlans />} />
              <Route path="payments"     element={<AdminPayments />} />
              <Route path="profile-req"  element={<AdminProfileRequests />} />
              <Route path="withdrawals"  element={<AdminWithdrawals />} />
              <Route path="fees"         element={<AdminFees />} />
              <Route path="transactions" element={<AdminTransactions />} />
              <Route path="commissions"  element={<AdminCommissions />} />
              <Route path="commission-payouts" element={<AdminCommissionPayouts />} />
              <Route path="user-slot-upgrades" element={<AdminUserSlotUpgrades />} />
              <Route path="user-totals" element={<AdminUserTotals />} />
              <Route path="performance-bonus" element={<AdminPerformanceBonus />} />
              <Route path="support-tickets" element={<AdminSupportTickets />} />
              <Route path="system-config"  element={<AdminSystemConfig />} />
              <Route path="missed-income"  element={<AdminMissedIncome />} />
              <Route path="missed-income/:userId" element={<AdminMissedIncomeDetail />} />
              <Route path="offer-credits"  element={<AdminOfferCredits />} />
              <Route path="login-history"  element={<AdminLoginHistory />} />
              <Route path="offer-promos"   element={<AdminOfferPromos />} />
              <Route path="offer-promos/new" element={<AdminOfferPromoForm />} />
              <Route path="offer-promos/:id/edit" element={<AdminOfferPromoForm />} />
            </Route>
          </Routes>
          <ToastContainer position="top-right" autoClose={3000} />
        </AuthProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
